import { render, staticRenderFns } from "./ServicePendency.vue?vue&type=template&id=2aed7d63&scoped=true"
import script from "./ServicePendency.vue?vue&type=script&lang=js"
export * from "./ServicePendency.vue?vue&type=script&lang=js"
import style0 from "./ServicePendency.vue?vue&type=style&index=0&id=2aed7d63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aed7d63",
  null
  
)

export default component.exports